
  import { css } from 'lit';
  export const styles = css`:host igc-popover::part(container){border-radius:var(--border-radius)}[part=base]{box-shadow:var(--elevation);background:var(--background-color);border-radius:var(--border-radius)}`;
  